// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);


// POS PWA: registra el app-shell para poder abrir React aun sin conexión.
// Solo se registra en producción para no interferir con hot reload/desarrollo.
if (process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    // Solicita almacenamiento persistente para reducir el riesgo de que el
    // navegador elimine IndexedDB/cache del POS ante presión de espacio.
    if (navigator.storage?.persist) {
      navigator.storage.persist().catch(() => false);
    }

    if (!('serviceWorker' in navigator)) return;

    navigator.serviceWorker
      .register('/service-worker.js', { scope: '/' })
      .then((registration) => {
        console.info('[IntegraNube POS] Service Worker activo:', registration.scope);
      })
      .catch((error) => {
        console.warn('[IntegraNube POS] No se pudo registrar Service Worker:', error);
      });
  });
}
